<ngx-smart-modal #pauseSubscriptionModal disableRefocus identifier="pauseSubscriptionModal"
  [customClass]="'pause-subscription-modal'">
  <div class="pause-modal-content">
    <h2 class="pause-modal-title">{{ 'ACCOUNT.BILLING.PAUSE_TITLE' | translate }}</h2>
    <p class="pause-modal-description">{{ 'ACCOUNT.BILLING.PAUSE_DESCRIPTION' | translate }}</p>

    <div class="pause-plan-card">
      <div class="pause-plan-header">{{ 'ACCOUNT.BILLING.PAUSE_PLAN_HEADER' | translate }}</div>
      <ul class="pause-plan-details">
        <li>{{ 'ACCOUNT.BILLING.PAUSE_DETAIL_ACCESS' | translate }}</li>
        <li>
          <span>{{ 'ACCOUNT.BILLING.PAUSE_DETAIL_NO_CALLS_PREFIX' | translate }}</span>
          <strong>{{ 'ACCOUNT.BILLING.PAUSE_DETAIL_NO_CALLS_BOLD' | translate }}</strong>
          <span>{{ 'ACCOUNT.BILLING.PAUSE_DETAIL_NO_CALLS_SUFFIX' | translate }}</span>
        </li>
        <li>
          <span>{{ 'ACCOUNT.BILLING.PAUSE_DETAIL_IMMEDIATE_PREFIX' | translate }}</span>
          <strong>{{ 'ACCOUNT.BILLING.PAUSE_DETAIL_IMMEDIATE_BOLD' | translate }}</strong>
          <span>{{ 'ACCOUNT.BILLING.PAUSE_DETAIL_IMMEDIATE_SUFFIX' | translate }}</span>
        </li>
      </ul>
    </div>

    <div class="pause-modal-actions">
      <rosie-button (click)="close()" [customClass]="'secondary slim text-sm'"
        [translationKey]="'COMMON.CANCEL'"></rosie-button>
      <rosie-button (click)="pause()" [inProgress]="isPausing" [customClass]="'slim text-sm'"
        [translationKey]="'ACCOUNT.BILLING.MOVE_TO_PAUSE_PLAN'"></rosie-button>
    </div>

    <p class="pause-modal-footer">
      {{ 'ACCOUNT.BILLING.PAUSE_CUSTOM_PREFIX' | translate }}
      <a href="mailto:support@heyrosie.com" class="pause-contact-link">{{ 'ACCOUNT.BILLING.PAUSE_CONTACT_US' | translate }}</a>
    </p>
  </div>
</ngx-smart-modal>
